module.exports = __webpack_public_path__ + "img/buessiness_htwl_h1.3d3cd21f.png";